// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import React from 'react';
import { useDispatch } from 'react-redux';

import { getCountriesData } from './../../store/countries/countriesReducer';
import { getProvincesData } from './../../store/provinces';
import DashboardContent from './DashboardContent';
import CommonLayout from 'src/components/CommonLayout';
import Styles from './dashboard.module.scss';

function Dashboard() {
    useDispatch()(getCountriesData());
    useDispatch()(getProvincesData());
    return (
        <div className={Styles.dashboard}>
            <CommonLayout>
                <DashboardContent />
            </CommonLayout>
        </div>
    );
}

export default Dashboard;
